import { render, staticRenderFns } from "./selectAgeOnBoarding.vue?vue&type=template&id=41d33844&scoped=true&"
import script from "./selectAgeOnBoarding.vue?vue&type=script&lang=js&"
export * from "./selectAgeOnBoarding.vue?vue&type=script&lang=js&"
import style0 from "./selectAgeOnBoarding.vue?vue&type=style&index=0&id=41d33844&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d33844",
  null
  
)

export default component.exports